<template>
  <div class="Uploader">
    <div class="card mb-2">
      <div class="card-body">
        <div class="upload-type-select">
          <div :class="{active: fileselectMode ==='FILE' }" @click="fileselectMode = 'FILE'">
            {{ i18n.COM_EVENTGALLERY_EVENT_UPLOAD_SELECT_LOCAL_FILES }}
          </div>
          <div :class="{active: fileselectMode ==='GOOGLE' }" @click="fileselectMode = 'GOOGLE'">
            {{ i18n.COM_EVENTGALLERY_EVENT_UPLOAD_SELECT_GOOGLE_PHOTOS }}
          </div>
        </div>

        <div>
          <label for="doresize">{{ i18n.COM_EVENTGALLERY_EVENT_UPLOAD_DO_RESIZE_LABEL.replace('%s', maxImageSize) }}:</label>
          <input
            id="doresize"
            v-model="doResize"
            type="checkbox"
            name="doresize"
          />
        </div>

        <GoogleFilePicker
          v-if="fileselectMode === 'GOOGLE'"
          :max-image-size="maxImageSize"
          :google-picker-urls="googlePickerUrls"
          :i18n="i18n"
          :do-resize="doResize"
          @add-file-callback="addFile"
        />
        <LocaLFilePicker
          v-if="fileselectMode === 'FILE'"
          :i18n="i18n"
          :do-resize="doResize"
          @add-file-callback="addFile"
        />
      </div>
    </div>

    <div v-if="pendingFiles.length + inProgressFiles.length > 0" class="card mb-2">
      <div class="card-body">
        <div class="eg-progressbar">
          <div class="eg-progressbar-state" :style="{width: progress + '%'}" />
        </div>
      </div>
    </div>

    <div class="card mb-2">
      <div class="eg-bo-row card-body">
        <div v-if="pendingFiles.length > 0" class="eg-bo-column3">
          <h2>{{ i18n.COM_EVENTGALLERY_EVENT_UPLOAD_PENDING }}</h2>
          <ul id="pending">
            <li v-for="pendingFile in revertedPendingFiles">
              {{ pendingFile.name }}
            </li>
          </ul>
        </div>

        <div v-if="finishedFilesContent.length > 0 || inProgressFiles.length > 0 || failedFilesContent.length > 0" class="eg-bo-column9">
          <h2>{{ i18n.COM_EVENTGALLERY_EVENT_UPLOAD_FINISHED }}</h2>
          <ul id="finished" class="eg-bo-row" style="flex-wrap: wrap; align-items: flex-start; justify-content: space-between;">
            <li v-for="inProgressFile in inProgressFiles" class="eg-bo-column3">
              <div>{{ inProgressFile.name }}</div>
              <div class="lds-ring">
                <div /><div /><div /><div />
              </div>
            </li>
            <li
              v-for="failedFileContent in failedFilesContent"
              :key="failedFileContent.id"
              class="eg-bo-column3"
              v-html="failedFileContent.content"
            />
            <li
              v-for="finishedFileContent in revertedFinishedFilesContent"
              :key="finishedFileContent.id"
              style="flex-basis: 300px;"
              v-html="finishedFileContent.content"
            />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { Helpers } from '../../../common/js/Helpers';
    import GoogleFilePicker from "./components/GoogleFilePicker.vue";
    import LocaLFilePicker from "./components/LocalFilePicker.vue";

    export default {
        components: {LocaLFilePicker, GoogleFilePicker},
        props: {
            i18n: null,
            uploadUrl: null,
            maxFileSize: null,
            maxImageSize: null,
            initDoResize: null,
            googlePickerUrls: null,
        },
        data() {
            return {
                pendingFiles: [],
                inProgressFiles: [],
                finishedFilesContent: [],
                failedFilesContent: [],
                doResize: this.initDoResize,
                fileselectMode: localStorage.getItem('eg-fileupload-mode') ?? 'FILE'
            };
        },
        computed: {
            progress: function() {
                const total = this.pendingFiles.length + this.inProgressFiles.length + this.finishedFilesContent.length + this.failedFilesContent.length;
                if (total === 0) return 0;
                return (total - this.pendingFiles.length) / total * 100;
            },
            revertedPendingFiles: function() {
                  return this.pendingFiles.slice().reverse();
            },
            revertedFinishedFilesContent: function() {
                return this.finishedFilesContent.slice().reverse();
            }
        },
        watch: {
            fileselectMode(newVal) {
                localStorage.setItem('eg-fileupload-mode', newVal)
            }
        },
        methods: {
            addFile: function (file) {
                console.log('adding file', file)
                this.pendingFiles.push(file);
                this.upload();
            },
            upload: function() {
                if (this.pendingFiles.length === 0 || this.inProgressFiles.length > 0) {
                    return;
                }

                let uploadFile = this.pendingFiles.pop();
                let localFile = uploadFile.localFile;
                let data = new FormData();
                let xhr = new XMLHttpRequest();

                if (xhr.upload && localFile.size <= this.maxFileSize) {

                    this.inProgressFiles.push(uploadFile);

                    // file received/failed
                    xhr.onreadystatechange = () => {
                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) {
                                this.finishedFilesContent.push({id: this.finishedFilesContent.length,'content':xhr.responseText});
                            } else {
                                this.failedFilesContent.push({id: this.failedFilesContent.length,'content': xhr.responseText});
                            }
                            Helpers.removeElement(this.inProgressFiles, uploadFile);
                            this.upload();
                        }
                    };

                    data.append('file', localFile, uploadFile.name);
                    data.append('doresize', uploadFile.doResize?'true':'false')

                    xhr.open("POST", this.uploadUrl, true);
                    xhr.send(data);

                } else {
                    console.log("invalid file, will not try to upload it");
                    this.upload();
                }
            }
        }
    };
</script>

<style scoped lang="less">
    @import "_Uploader.less";



    .eg-progressbar {
        margin: 0;
        background-color: rgba(243, 156, 18, 0.15);
        .eg-progressbar-state {
            height: 20px;
        }
    }

    .upload-type-select {
        /* Primärfarben-Definition mit separaten HSL-Komponenten */
        --color-primary: #007db0;
        --color-primary-h: 196; /* Farbton von #007db0 */
        --color-primary-s: 100%; /* Sättigung von #007db0 */
        --color-primary-l: 35%; /* Helligkeit von #007db0 */
        --color-primary-darker: hsl(var(--color-primary-h), var(--color-primary-s), calc(var(--color-primary-l) - 5%));
        --color-primary-darkest: hsl(var(--color-primary-h), var(--color-primary-s), calc(var(--color-primary-l) - 10%));

        /* Sekundärfarben-Definition mit separaten HSL-Komponenten */
        --color-secondary: #CFCFCF;
        --color-secondary-h: 0; /* Farbton von #CFCFCF */
        --color-secondary-s: 0%; /* Sättigung von #CFCFCF */
        --color-secondary-l: 81%; /* Helligkeit von #CFCFCF */
        --color-secondary-darker: hsl(var(--color-secondary-h), var(--color-secondary-s), calc(var(--color-secondary-l) - 5%));
        --color-secondary-darkest: hsl(var(--color-secondary-h), var(--color-secondary-s), calc(var(--color-secondary-l) - 10%));

        display: flex;
        flex-wrap: nowrap;
        justify-content: space-evenly;
        margin-bottom: 20px;
        cursor: pointer;

        div:first-child {
            border-top-left-radius: 5px;
        }

        div:last-child {
            border-top-right-radius: 5px;
        }

        div {
            background-color: var(--color-secondary);
            padding: 10px;
            width: 100%;
        }

        div:hover {
            background-color: var(--color-secondary-darker);
            font-weight: bold;
        }
        div.active {
            background-color: var(--color-primary);
            color: white;
            font-weight: bolder;
        }
        div.active:hover {
            background-color: var(--color-primary-darker);
        }
    }
</style>
